import { B2Modal } from 'react-b2components';
import { MdClose, MdMenu } from 'react-icons/md';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const HamburgerMenu = styled(MdMenu)`
  color: ${({ theme }) => theme.colors.main};
  width: 24px;
  height: 24px;
  cursor: pointer;
  margin-right: 10px;

  @media (min-width: 769px) {
    display: none;
  }
`;

export const Modal = styled(B2Modal)`
  background-color: ${({ theme }) => theme.colors.main};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 0px;
  padding: 0;
  z-index: 2147483647;
`;

export const CloseButton = styled(MdClose)`
  color: ${({ theme }) => theme.colors.white};
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 30px;
`;

export const MenuItem = styled(Link)`
  color: ${({ theme }) => theme.colors.white.two};
  text-decoration: none;
  margin: 5px 0px;
`;

export const SideBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
